import { ComponentAccess } from '../useCurrentAccessPolicy';

export const administrationPolicy: ComponentAccess = {
  // LIMS
  canAccessLims: false,
  canCreateOrders: false,
  canEditOrders: false,
  canDeleteOrders: false,
  canManageSpecimens: false,
  canViewDiagnosticReports: false,
  canCreateDiagnosticReports: false,
  canReviewResults: false,
  canManageConsent: false,

  // Admin
  canAccessAdmin: false,
  canManageUsers: false,
  canManageAccessPolicies: false,
  canViewSystemStats: true,

  // Patient Management
  canAccessPatients: true,
  canCreatePatients: false,
  canEditPatients: false,
  canViewPatientHistory: true,
  canManageEncounters: false,
  canViewEncounters: false,

  // Tasks & Workflow
  canAccessTasks: true,
  canClaimTasks: true,
  canAssignTasks: false,
  canCompleteTasksForOthers: false,

  // Practitioner Management
  canAccessPractitioners: true,
  canViewPractitioners: true,
  canManagePractitioners: false,

  // Payment & Billing
  canAccessPayments: true,
  canManageChargeItems: true,
  canManageInvoices: true,
  canViewBillingAccounts: true,

  // Search
  canAccessSearch: true,

  // General
  canViewReports: true,
  canExportData: true,
  canManageDocuments: false,
};
